import {
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
    SET_PRODUCTSGUIDE,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
    CLEAR_PRODUCTS_GUIDE,
    VALIDATE_PRODUCTS,
    CLEAR_VALIDATED_PRODUCTS,
    SET_CART_DATA,
    SET_PRODUCTGUIDE_FILTER_OPEN,
    SET_SELECTED_CATEGORY,
    SET_APPLIED_FILTER,
    MORE_GET_PRODUCTS,
    SET_SELECTED_CATEGORY_FILTER,
    SET_SELECTED_SUB,
    GET_PRODUCT_CATOGORY_LIST,
    SET_APPLIED_BRAND_VALUES,
    SET_PAGE_NUM,
    SET_SUB_CATEGORY,
    GLOBAL_FILTER_OPEN,
    CLOSE_SHOW_PAGE,
    SET_APPLIED_SUBCATEGORY,
    UPDATE_SUBCATEGORY_REFINE_DATA,
    UPDATE_BRANDS_DATA,
    SET_APPLIED_BRANDS,
    SET_PRODUCT_GUIDE_VALUES,
    SET_SELECTED_TAB,
    SET_SORT_CODE,
    CLEAR_PRODUCTS_GUIDE_DATA,
} from 'src/pages/more/pages/productGuide/redux/action/actionTypes';

export const getProductsCategoryAndBrands = (data) => {
    return {
        type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
        payload: data,
    };
};
export const setShowPage = (data) => {
    return {
        type: CLOSE_SHOW_PAGE,
        payload: data,
    };
};

export const setProductsGuide = (productsGuideList, name) => {
    return {
        type: SET_PRODUCTSGUIDE,
        payload: productsGuideList,
        name: name,
    };
};

export const getProductsByBrandOrSuperCategory = (data) => {
    return {
        type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
        payload: data,
    };
};

export const clearProductsGuide = () => {
    return {
        type: CLEAR_PRODUCTS_GUIDE,
    };
};

export const clearProductsGuideData = () => {
    return {
        type: CLEAR_PRODUCTS_GUIDE_DATA,
    };
};

export const validateProducts = (products) => {
    return {
        type: VALIDATE_PRODUCTS,
        payload: products,
    };
};

export const clearValidatedProducts = () => {
    return {
        type: CLEAR_VALIDATED_PRODUCTS,
    };
};

export const setCartData = (cartData) => {
    return {
        type: SET_CART_DATA,
        payload: cartData,
    };
};

export const setProductGuideFilterOpen = (payload) => {
    return {
        type: SET_PRODUCTGUIDE_FILTER_OPEN,
        payload: payload,
    };
};

export const setSelectedCategory = (payload) => {
    return {
        type: SET_SELECTED_CATEGORY,
        payload: payload,
    };
};

export const setAppliedFilter = (payload) => {
    return {
        type: SET_APPLIED_FILTER,
        payload: payload,
    };
};

export const searchProducts = (queryParam) => {
    return {
        type: MORE_GET_PRODUCTS,
        payload: queryParam,
    };
};

export const setSelectedCategoryFilter = (payload) => {
    return {
        type: SET_SELECTED_CATEGORY_FILTER,
        payload: payload,
    };
};

export const setSelectedSubCat = (payload) => {
    return {
        type: SET_SELECTED_SUB,
        payload: payload,
    };
};
export const getProductFilterCatogories = (payload) => {
    return {
        type: GET_PRODUCT_CATOGORY_LIST,
        payload: payload,
    };
};

export const setAppliedBrandValues = (payload) => {
    return {
        type: SET_APPLIED_BRAND_VALUES,
        payload: payload,
    };
};

export const setPageNum = (payload) => {
    return {
        type: SET_PAGE_NUM,
        payload: payload,
    };
};

export const setSubCategory = (payload) => {
    return {
        type: SET_SUB_CATEGORY,
        payload: payload,
    };
};

export const globalFilterOpen = (payload) => {
    return {
        type: GLOBAL_FILTER_OPEN,
        payload: payload,
    };
};

export const setAppliedSubCategory = (payload) => {
    return {
        type: SET_APPLIED_SUBCATEGORY,
        payload: payload,
    };
};
export const updateSubCategoryRefineData = (payload) => {
    return {
        type: UPDATE_SUBCATEGORY_REFINE_DATA,
        payload: payload,
    };
};
export const setAppliedBrands = (payload) => {
    return {
        type: SET_APPLIED_BRANDS,
        payload: payload,
    };
};
export const updateBrandData = (payload) => {
    return {
        type: UPDATE_BRANDS_DATA,
        payload: payload,
    };
};

export const setProductGuideValue = (payload) => {
    return {
        type: SET_PRODUCT_GUIDE_VALUES,
        payload: payload,
    };
};

export const setSelectedTab = (payload) => {
    return {
        type: SET_SELECTED_TAB,
        payload: payload,
    };
};

export const setSortCode = (payload) => {
    return {
        type: SET_SORT_CODE,
        payload: payload,
    };
};
